module.exports = __webpack_public_path__ + "static/img/ent-detail-85.3722620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-85.jpg
// module id = +A0U
// module chunks = 52